module.exports = __webpack_public_path__ + "c5e646bce3f71d4e1b2297bda6e47b33.fbx";